import { render, staticRenderFns } from "./VContent.vue?vue&type=template&id=febf1512&scoped=true&"
import script from "./VContent.vue?vue&type=script&lang=js&"
export * from "./VContent.vue?vue&type=script&lang=js&"
import style0 from "./VContent.vue?vue&type=style&index=0&id=febf1512&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "febf1512",
  null
  
)

export default component.exports